/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_impact_method_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Méthode <span class="text-blue-400">I</span>.<span class="text-blue-400">M</span>.<span class="text-juslin-gold">P</span>.<span class="text-juslin-gold">A</span>.<span class="text-blue-400">C</span>.<span class="text-juslin-gold">T</span>`)
};

const en_impact_method_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The <span class="text-blue-400">I</span>.<span class="text-blue-400">M</span>.<span class="text-juslin-gold">P</span>.<span class="text-juslin-gold">A</span>.<span class="text-blue-400">C</span>.<span class="text-juslin-gold">T</span> Method`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const impact_method_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.impact_method_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("impact_method_label", locale)
	if (locale === "fr") return fr_impact_method_label(inputs)
	return en_impact_method_label(inputs)
};